import _fails from "../internals/fails";
import _globalThis2 from "../internals/global-this";
var exports = {};
var fails = _fails;
var _globalThis = _globalThis2;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = _globalThis.RegExp;
var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp("a", "y");
  re.lastIndex = 2;
  return re.exec("abcd") !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp("a", "y").sticky;
});
var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp("^r", "gy");
  re.lastIndex = 2;
  return re.exec("str") !== null;
});
exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};
export default exports;
const _BROKEN_CARET = exports.BROKEN_CARET,
  _MISSED_STICKY = exports.MISSED_STICKY,
  _UNSUPPORTED_Y = exports.UNSUPPORTED_Y;
export { _BROKEN_CARET as BROKEN_CARET, _MISSED_STICKY as MISSED_STICKY, _UNSUPPORTED_Y as UNSUPPORTED_Y };